import { RouteConfig } from 'vue-router';
import UnifiedInsights from './unified-insights.vue';

export const UnifiedInsightsRoute: RouteConfig = { // tslint:disable-line:variable-name
  path: 'unified-insights',
  component: UnifiedInsights,
};

export function getMyDefaultParams() {
  return {};
}
export default UnifiedInsightsRoute;
